export default __webpack_public_path__ + "static/media/wise-systems.4f7b9bd9.svg";